export enum WalletType {
  ApplePay = 1,
  GooglePay = 2,
  SamsungPay = 3
}

export type IDigitalWalletPaymentRequest = {
    type:WalletType
    walletKey:string
    ephemeralPublicKey:string
    signature:string
};

